type OwnerDogCounts = {
    count_male_dogs?: unknown;
    count_female_dogs?: unknown;
};

/** Summary line for admin lists (owner's male / female dog totals). */
export function formatOwnerDogCounts(record: OwnerDogCounts | null | undefined): string {
    if (!record) {
        return '—';
    }
    const male = Number(record.count_male_dogs) || 0;
    const female = Number(record.count_female_dogs) || 0;
    if (!male && !female) {
        return '—';
    }
    const parts: string[] = [];
    if (male) {
        parts.push(`${male} male`);
    }
    if (female) {
        parts.push(`${female} female`);
    }
    return parts.join(', ');
}
